import React from 'react'
import { Link } from 'react-router'
import styles from './DashboardCards.scss'
import { messages as challengeMessages } from '../Challenges'
import { SecondaryColCard } from 'features/challenges/admin/Overview'
import { SectionBox } from 'common/styleguide/SectionBox'
import { CircledIcon } from 'common/CircledIcon'
import { useFormatMessage, featureNames } from 'lib/localization'
import { urlWithPrivacyCode } from 'lib/utils'
import { defineMessages } from 'react-intl'

const messages = defineMessages({
  viewChallenges: {
    id: 'DashboardCards.viewChallenges',
    defaultMessage: 'View Challenges'
  },
  trailer: {
    id: 'DashboardCards.trailer',
    defaultMessage: '#{rank} ranking with {amount}'
  }
})

export const CurrentChallenges = ({ challenges }) => {
  const fm = useFormatMessage()

  if (challenges.size === 0) {
    return (
      <div className={styles.aOverwrite}>
        <SecondaryColCard
          title={fm(featureNames.challenges)}
          top={<div className={styles.emptyCard}>
            <div className={styles.emptyTop}>
              <CircledIcon i='md-trophy' size={40} />
              {fm(challengeMessages.noCurrent)}
            </div>
          </div>}
          to='/challenges'
          link={fm(messages.viewChallenges)}
        />
      </div>
    )
  }

  return <SectionBox title={fm(featureNames.challenges)} className={styles.challengesCard}>
    <div className={styles.rows}>
      {challenges.map(c => <MiniChallengeRow key={c.id} c={c} fm={fm} />).toIndexedSeq()}
    </div>
    <Link to='/challenges'>{fm(messages.viewChallenges)}</Link>
  </SectionBox>
}

const MiniChallengeRow = ({ c, fm }) => {
  return <Link
    to={urlWithPrivacyCode(`/challenges/${c.getIn(['goal', 'id'])}`, c.getIn(['goal', 'privacy_code', 'code']))}
    className={styles.challengeRow}
  >
    <img height='60' src={c.getIn(['goal', 'icon'])} />
    <div className={styles.info}>
      <div className={styles.name}>{c.getIn(['goal', 'name'])}</div>
      <div className={styles.trailer}>{c.getIn(['goal_params', 'long_trailer'])}</div>
    </div>
  </Link>
}
